import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface Order {
  id: string;
  shopifyOrderNumber: string;
  customerName: string;
  customerPhone: string;
  deliveryAddress: string;
  deliveryCity: string;
  deliveryState: string;
  deliveryZip: string;
  status: OrderStatus;
  createdAt: string;
  markedReadyAt: string | null;
  quotes: Quote[];
  deliveries: Delivery[];
}

export type OrderStatus =
  | 'PENDING'
  | 'READY'
  | 'QUOTE_SENT'
  | 'QUOTE_APPROVED'
  | 'IN_DELIVERY'
  | 'DELIVERED'
  | 'CANCELLED'
  | 'FAILED';

export interface Quote {
  id: string;
  priceAmount: number;
  priceCurrency: string;
  expiresAt: string;
  status: string;
}

export interface Delivery {
  id: string;
  uberDeliveryId: string;
  driverName: string | null;
  driverPhone: string | null;
  status: DeliveryStatus;
  etaMinutes: number | null;
  pickedUpAt: string | null;
  deliveredAt: string | null;
}

export type DeliveryStatus =
  | 'PENDING'
  | 'DRIVER_ASSIGNED'
  | 'EN_ROUTE_TO_PICKUP'
  | 'ARRIVED_AT_PICKUP'
  | 'PICKED_UP'
  | 'EN_ROUTE_TO_DROPOFF'
  | 'ARRIVED_AT_DROPOFF'
  | 'DELIVERED'
  | 'CANCELLED'
  | 'FAILED';

export async function getOrders(params?: {
  storeId?: string;
  status?: OrderStatus;
}): Promise<Order[]> {
  const response = await api.get('/orders', { params });
  return response.data.orders;
}

export async function getOrder(id: string): Promise<Order> {
  const response = await api.get(`/orders/${id}`);
  return response.data.order;
}

export async function markOrderReady(id: string): Promise<{ quote: Quote }> {
  const response = await api.post(`/orders/${id}/ready`);
  return response.data;
}

export async function approveQuote(
  id: string,
  token: string
): Promise<{ delivery: Delivery }> {
  const response = await api.post(`/orders/${id}/approve`, { token });
  return response.data;
}

export async function submitTip(id: string, amount: number): Promise<void> {
  await api.post(`/orders/${id}/tip`, { amount });
}

export default api;
